import React, { forwardRef, useState, useCallback } from 'react';
import { TextField, Select, MenuItem } from '@material-ui/core';
import MaterialTable from 'material-table';
import { useHistory } from 'react-router';
import { safeGet } from '../../axios-default';
import QueryString from 'querystring';
import Modal from '../../components/Modal/modal';
import DragAndDrop from '../../components/NewPatient/Photos/DragAndDrop';
import style from './PageBanner.module.css';
import axios from '../../axios-default';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import { ApiServerUrl } from '../../config.json';
import { useDispatch } from 'react-redux';
import { easySnackbar } from '../../store/Noti/noti.actions';
import {
    Close as CloseIcon,
    Check as CheckIcon,
    AddBox,
    ArrowDownward,
    Check,
    ChevronLeft,
    ChevronRight,
    Clear,
    DeleteOutline,
    Edit,
    FilterList,
    FirstPage,
    LastPage,
    Remove,
    SaveAlt,
    Search,
    ViewColumn,
} from '@material-ui/icons';
import { Edit as EditIcon } from '@material-ui/icons';
import join from 'url-join';

const TableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
};

export const ProductMatrixTable = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const [loading, setLoading] = useState(true),
        [search, setSearch] = useState(''),
        [modalOpen, setModalOpen] = useState(false),
        [updatedProductMatrix, setUpdatedProductMatrix] = useState({ pmData: Object.assign({}) });

    const fileToBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            if (file) {
                reader.readAsDataURL(file);
            }
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => reject(error);
        });

    const handleNewPhoto = useCallback(
        async (file) => {
            let data = undefined;
            if (file) {
                data = await fileToBase64(file);
            } else {
                const updatedProductMatrixCopy = { ...updatedProductMatrix };
                delete updatedProductMatrixCopy.pmData.product_image_new;
                setUpdatedProductMatrix(updatedProductMatrixCopy);
                return;
            }

            setUpdatedProductMatrix({
                ...updatedProductMatrix,
                pmData: {
                    ...updatedProductMatrix.pmData,
                    product_image_new: data,
                },
            });
        },
        [updatedProductMatrix]
    );

    const handleColorChange = (color_code) => {
        setUpdatedProductMatrix({
            ...updatedProductMatrix,
            pmData: {
                ...updatedProductMatrix.pmData,
                color_code,
            },
        });
    };

    const reloadPage = () => {
        const curPage = window.location.pathname;
        history.push('/blank');
        history.replace(curPage);
    };

    const handleSave = useCallback(async () => {
        try {
            if (loading) return;
            setLoading(true);

            await axios.post(`productmatrix/update`, updatedProductMatrix.pmData);

            window.scroll({ top: 0, left: 0, behavior: 'smooth' });
            dispatch(easySnackbar('Success', 'success'));

            //dispatch(updateRes('admin_groups'))
            reloadPage();
            setLoading(true);
            setModalOpen(false);
        } catch (err) {
        } finally {
            setLoading(false);
        }
    }, [updatedProductMatrix]);

    const dataGetter = useCallback(
        async (query) => {
            const { pageSize, page: pageNo, search, orderBy, orderDirection } = query;
            try {
                const { pm: data, total } = await safeGet(
                    `productmatrix?${QueryString.encode({
                        pageNo,
                        pageSize,
                        search,
                        sortBy: orderBy?.field,
                        sortDir: orderDirection,
                    })}`
                );
                if (loading) setLoading(false);
                return {
                    data: data.filter(({ deleted_flag }) => !deleted_flag),
                    page: pageNo ?? 0,
                    totalCount: total ?? 0,
                };
            } catch (err) {
                console.error(err);
            }
        },
        [search]
    );

    var columns = [
        {
            field: 'product_name',
            title: 'Product name',
            sorting: true,
            filtering: true,
        },
        {
            field: 'product_desc',
            title: 'Product Description',
            sorting: true,
            filtering: true,
        },
        {
            field: 'image',
            title: 'Product Image',
            render: (rowData) => rowData.product_image ? (
                <div style={{ height: '150px', width: '150px', backgroundColor: rowData.color_code }}>
                    <img style={{ width: '100%' }} src={join(ApiServerUrl, 'file/config/', rowData.product_image)} />
                </div>
            ) : null,
            sorting: false,
            filtering: false,
        },
    ];

    if (['SADMIN', 'ADMIN'].includes(JSON.parse(localStorage.getItem('role')))) {
        columns.push({
            field: 'group_name',
            title: 'Group',
            sorting: true,
            filtering: false,
            defaultSort: 'asc',
        });
    }

    columns.push({
        field: 'enable_flag',
        title: 'Enabled',
        sorting: true,
        filtering: true,
        render: (rowData) => (
            <div style={{ display: 'flex', justifyContent: 'center', margin: '0px 4px', width: 40, height: 40 }}>
                {rowData.enable_flag ? <CheckIcon /> : <CloseIcon />}
            </div>
        ),
    });

    return (
        <>
            <MaterialTable
                title="Products List"
                data={dataGetter}
                actions={[
                    {
                        icon: () => <EditIcon />,
                        tooltip: 'Edit Row',
                        onClick: (_, data) => {
                            setUpdatedProductMatrix({ pmData: Object.assign({}, data) });
                            setModalOpen(true);
                        },
                    },
                ]}
                columns={columns}
                options={{
                    initialPage: 0,
                    emptyRowsWhenPaging: false,
                    exportAllData: false,
                    debounceInterval: 700,
                    columnsButton: true,
                    pageSize: 30,
                    search: false,
                    pageSizeOptions: [10, 15, 30, 50, 100],
                    minBodyHeight: 700,
                    exportButton: false,
                }}
                icons={TableIcons}
                isLoading={loading}
            />
            <Modal
                className="modal"
                modal="Distributor Group"
                title={`Product (${updatedProductMatrix.pmData.product_name})`}
                open={modalOpen}
                handleClose={() => {
                    setModalOpen(false);
                }}
                handleDataSave={() => handleSave()}
                //modalError={this.modalError}
                submitButton={true}
            >
                <TextField
                    fullWidth
                    label="Product Name"
                    variant="filled"
                    value={updatedProductMatrix.pmData.product_name}
                    onChange={({ target }) => {
                        setUpdatedProductMatrix({
                            ...updatedProductMatrix,
                            pmData: {
                                ...updatedProductMatrix.pmData,
                                product_name: target.value,
                            },
                        });
                    }}
                />

                <TextField
                    fullWidth
                    label="Product Description"
                    variant="filled"
                    value={updatedProductMatrix.pmData.product_desc}
                    onChange={({ target }) => {
                        setUpdatedProductMatrix({
                            ...updatedProductMatrix,
                            pmData: {
                                ...updatedProductMatrix.pmData,
                                product_desc: target.value,
                            },
                        });
                    }}
                    multiline
                    rows={4}
                />

                <p>Current Image</p>
                <img
                    style={{ width: '400px' }}
                    src={ApiServerUrl + 'file/config/' + updatedProductMatrix.pmData.product_image}
                    alt="Current Image"
                />

                <DragAndDrop handleDrop={(file) => handleNewPhoto(file)}>
                    {
                        //!this.state.photo.newPhoto ?
                        !updatedProductMatrix.pmData.product_image_new ? (
                            <div className={style.imageUploadArea}>
                                <button className={style.remove}>
                                    <DeleteOutlineOutlinedIcon />
                                </button>

                                <span>Upload New Photo</span>
                                <div className={style.uploadBtnWrapper}>
                                    <button className={style.uploadBtn}>+</button>
                                    <input
                                        type="file"
                                        onChange={({ target }) => {
                                            handleNewPhoto(target.files[0]);
                                        }}
                                        accept="image/*"
                                        name="patientImage"
                                        id="patientImage"
                                    />
                                </div>
                            </div>
                        ) : (
                            <div className={style.imageUploadArea}>
                                <button className={style.remove} onClick={() => handleNewPhoto(undefined)}>
                                    <DeleteOutlineOutlinedIcon />
                                </button>
                                <img
                                    style={{ width: '100%', maxHeight: '400px' }}
                                    src={updatedProductMatrix.pmData.product_image_new}
                                />
                            </div>
                        )
                    }
                </DragAndDrop>

                <p>Background Color</p>
                <input
                    type="color"
                    value={updatedProductMatrix.pmData.color_code}
                    onChange={({ target }) => handleColorChange(target.value)}
                    style={{ width: '300px', height: '300px' }}
                />

                <p>Enable</p>
                <Select
                    value={updatedProductMatrix.pmData.enable_flag}
                    label="Enable"
                    onChange={({ target }) => {
                        setUpdatedProductMatrix({
                            ...updatedProductMatrix,
                            pmData: {
                                ...updatedProductMatrix.pmData,
                                enable_flag: target.value,
                            },
                        });
                    }}
                >
                    <MenuItem value={false}>Off</MenuItem>
                    <MenuItem value={true}>On</MenuItem>
                </Select>
            </Modal>
        </>
    );
};

export default ProductMatrixTable;
